import React, { useEffect, useState } from 'react';

import { Button } from '@ariakit/react';
import classNames from 'classnames';
import { motion, AnimatePresence } from 'framer-motion';

import { ReactComponent as Chevron } from '../../assets/images/icons/Chevron.svg';

import * as classes from './style.module.scss';

interface Props {
  title?: string;
  active?: boolean;
  collapsible?: boolean;
  defaultOpen?: boolean;
  depth?: number;
}

export const NavigationCategory: React.FC<Props> = ({
  title,
  active,
  children,
  collapsible = true,
  defaultOpen = true,
  depth = 0,
}) => {
  const [open, setOpen] = useState(defaultOpen || active);

  useEffect(() => {
    if (active) {
      setOpen(active);
    }
  }, [active]);

  const handleClick = () => {
    if (collapsible) {
      setOpen(!open);
    }
  };

  return (
    <div
      className={classNames(classes.root, { [classes.subcategory]: depth > 0 })}
    >
      {title && (
        <Button
          className={classNames(classes.title, {
            [classes.collapsible]: collapsible,
            [classes.subcategorytitle]: depth > 0,
          })}
          onClick={handleClick}
          aria-hidden={!collapsible}
          aria-expanded={open}
          role="button"
        >
          {collapsible && (
            <motion.div
              initial={{ rotate: open ? 0 : -90 }}
              animate={{ rotate: open ? 0 : -90 }}
            >
              <Chevron />
            </motion.div>
          )}
          {title}
        </Button>
      )}
      <AnimatePresence initial={false}>
        {open && (
          <motion.section
            className={classes.section}
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: {
                opacity: 1,
                height: 'auto',
                transitionEnd: { overflow: 'visible' },
              },
              collapsed: {
                opacity: 0,
                height: 0,
                overflow: 'hidden',
              },
            }}
            transition={{ duration: 0.225, ease: 'easeInOut' }}
          >
            <ul className={classes.category}>{children}</ul>
          </motion.section>
        )}
      </AnimatePresence>
    </div>
  );
};
